export default class ValidationService {
  isString (str) {
    return typeof str === 'string'
  }
  isRijksregisternummer (n) {
    n = n.split('_').join('')
    n = n.split('-').join('')
    n = n.split('.').join('')
    if (!this.isString(n)) {
      return [false, 'Rijksregisternummer is niet ingevuld']
    }

    if (n.length !== 11) {
      return [false, 'Rijksregisternummer moet 11 karakters lang zijn']
    }

    let checkDigit = n.substr(n.length - 2, 2)
    let modFunction = function (nr) {
      return 97 - (nr % 97)
    }
    let nrToCheck = parseInt(n.substr(0, 9))

    // first check without 2
    if (modFunction(nrToCheck) + '' == checkDigit) { // eslint-disable-line
      return [true, '']
    }

    // then check with 2 appended for y2k+ births
    nrToCheck = parseInt('2' + n.substr(0, 9))

    if (modFunction(nrToCheck) + '' !== checkDigit) {
      return [false, 'Ongeldig rijksregisternummer']
    }
    return [true, '']
  }
  isIban (input) {
       /*
     * Returns 1 if the IBAN is valid 
     * Returns FALSE if the IBAN's length is not as should be (for CY the IBAN Should be 28 chars long starting with CY )
     * Returns any other number (checksum) when the IBAN is invalid (check digits do not match)
     */
    var CODE_LENGTHS = {
      AD: 24, AE: 23, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29,
      CH: 21, CR: 21, CY: 28, CZ: 24, DE: 22, DK: 18, DO: 28, EE: 20, ES: 24,
      FI: 18, FO: 18, FR: 27, GB: 22, GI: 23, GL: 18, GR: 27, GT: 28, HR: 21,
      HU: 28, IE: 22, IL: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28,
      LI: 21, LT: 20, LU: 20, LV: 21, MC: 27, MD: 24, ME: 22, MK: 19, MR: 27,
      MT: 31, MU: 30, NL: 18, NO: 15, PK: 24, PL: 28, PS: 29, PT: 25, QA: 29,
      RO: 24, RS: 22, SA: 24, SE: 24, SI: 19, SK: 24, SM: 27, TN: 24, TR: 26
  };
  var iban = String(input).toUpperCase().replace(/[^A-Z0-9]/g, ''), // keep only alphanumeric characters
          code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/), // match and capture (1) the country code, (2) the check digits, and (3) the rest
          digits;
  // check syntax and length
  if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
      return [false,'Check IBAN length of characters.'];
  }
  // rearrange country code and check digits, and convert chars to ints
  digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (letter) {
      return letter.charCodeAt(0) - 55;
  });
  // final check

  
  if (this.mod97(digits)===1) {
    return [true, '']
  }else{
    return [false,'Ongeldig IBAN-nummer']
  }
  
}
 mod97(string) {
  var checksum = string.slice(0, 2), fragment;
  for (var offset = 2; offset < string.length; offset += 7) {
      fragment = String(checksum) + string.substring(offset, offset + 7);
      checksum = parseInt(fragment, 10) % 97;
  }
  return checksum;
}

  
  isStraat (n) {
    if (!this.isString(n)) {
      return [false, 'Straat is niet ingevuld']
    }
    if (n.length < 2) {
      return [false, 'Straat moet minstens 2 karakters lang zijn']
    }
    return [true, '']
  }

  isHuisnummer (n) {
    if (!this.isString(n)) {
      return [false, 'Huisnummer is niet ingevuld']
    }
    if (n.length < 2) {
      return [false, 'Huisnummer moet minstens 1 karakters lang zijn']
    }
    return [true, '']
  }

  isGemeente (n) {
    if (!this.isString(n)) {
      return [false, 'Gemeente is niet ingevuld']
    }
    if (n.length < 2) {
      return [false, 'Gemeente moet minstens 2 karakters lang zijn']
    }
    return [true, '']
  }

  isPostcode (n) {
    if (!this.isString(n)) {
      return [false, 'Postcode is niet ingevuld']
    }
    if (n.length !== 4) {
      return [false, 'Postcode moet 4 karakters lang zijn']
    }
    return [true, '']
  }

  isGemeenteRecord (n) {
    if (n === null || n.ID === undefined || n.ID === null || n.ID < 0) {
      return [false, 'Gemeente is niet ingevuld']
    }
    return [true, '']
  }

  isTelefoon (n) {
    n = n.split('_').join('')
    n = n.split('/').join('')
    n = n.split('.').join('')
    if (!this.isString(n)) {
      return [false, 'Telefoonnummer is niet ingevuld']
    }
    if (n.length < 9) {
      return [false, 'Telefoonnummer moet minstens 9 karakters lang zijn']
    }
    return [true, '']
  }

  isGSM (n) {
    n = n.split('_').join('')
    n = n.split('/').join('')
    n = n.split('.').join('')
    if (!this.isString(n)) {
      return [false, 'GSM nummer is niet ingevuld']
    }
    if (n.length < 9 ) {
      return [false, 'GSM nummer moet minstens 9 karakters lang zijn']
    }
    return [true, '']
  }

  validateEmail (email) {
    /*eslint-disable */
    let re =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    /* eslint-enable */
    return re.test(email)
  }

  isEmail (n) {
    if (!this.isString(n)) {
      return [false, 'Emailadres is niet ingevuld']
    }
    if (n.length < 4) {
      return [false, 'Emailadres moet minstens 3 karakters lang zijn']
    }
    if (!this.validateEmail(n)) {
      return [false, 'Gelieve een geldig emailadres op te geven']
    }
    return [true, '']
  }

  isGeboortedatum (n) {
    n = n.split('_').join('')
    n = n.split('/').join('')
    if (!this.isString(n)) {
      return [false, 'Geboortedatum is niet ingevuld']
    }
    if (n.length !== 8) {
      return [false, 'Geboortedatum moet 8 karakters lang zijn']
    }
    return [true, '']
  }
  isNaam (name) {
    if (!this.isString(name)) {
      return [false, 'Naam is niet ingevuld']
    }
    if (name.length < 2) {
      return [false, 'Naam moet minstens 2 karakters lang zijn']
    }
    if (name.length > 64) {
      return [false, 'Naam mag niet langer zijn dan 64 karakters']
    }
    return [true, '']
  }
  isVoornaam (name) {
    if (!this.isString(name)) {
      return [false, 'Voornaam is niet ingevuld']
    }
    if (name.length < 2) {
      return [false, 'Voornaam moet minstens 2 karakters lang zijn']
    }
    if (name.length > 64) {
      return [false, 'Voornaam mag niet langer zijn dan 64 karakters']
    }
    return [true, '']
  }
  isConnectionName (name) {
    if (!this.isString(name)) {
      return [false, 'Naam connectie is niet ingevuld']
    }
    if (name.length < 2) {
      return [false, 'Naam connectie moet minstens 2 karakters lang zijn']
    }
    if (name.length > 64) {
      return [false, 'Naam connectie mag niet langer zijn dan 64 karakters']
    }
    return [true, '']
  }
  isUsername (name) {
    if (!this.isString(name)) {
      return [false, 'Gebruikersnaam is niet ingevuld']
    }
    if (name.length < 2) {
      return [false, 'Gebruikersnaam moet minstens 2 karakters lang zijn']
    }
    if (name.length > 64) {
      return [false, 'Gebruikersnaam mag niet langer zijn dan 64 karakters']
    }
    return [true, '']
  }
  isPassword (pwd) {
    if (!this.isString(pwd)) {
      return [false, 'Wachtwoord is niet ingevuld']
    }
    if (pwd.length < 2) {
      return [false, 'Wachtwoord moet minstens 2 karakters lang zijn']
    }
    if (pwd.length > 64) {
      return [false, 'Wachtwoord mag niet langer zijn dan 64 karakters']
    }
    return [true, '']
  }
  isServerLocation (name) {
    if (!this.isString(name)) {
      return [false, 'Server locatie is niet ingevuld']
    }
    if (name.length > 255) {
      return [false, 'Server locatie mag niet langer zijn dan 1024 karakters']
    }
    name = name.toLowerCase()
    if (name.indexOf('https://') !== 0 && name.indexOf('http://') !== 0 && name.indexOf('www.') !== 0) {
      return [false, "Server locatie moet beginnen 'http', 'https' of 'www' "]
    }
    return [true, '']
  }
}
